// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.control-panel {
  font-family: 'Hack', monospace;
  font-size: 11px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: default;
  text-align: left;
  box-sizing: border-box;
}

.control-panel input {
  font-family: 'Hack';
  font-size: 11px;
}

.control-panel a {
  color: inherit;
  text-decoration: none;
}

.container {
  position: relative;
  min-height: 25px;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/base.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".control-panel {\n  font-family: 'Hack', monospace;\n  font-size: 11px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  cursor: default;\n  text-align: left;\n  box-sizing: border-box;\n}\n\n.control-panel input {\n  font-family: 'Hack';\n  font-size: 11px;\n}\n\n.control-panel a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.container {\n  position: relative;\n  min-height: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
